import React from "react";
import { useStyles } from "./styles";
import { Tooltip as MUITooltip } from "@material-ui/core";
/* -------------------------------------------------------------------------- */
export default function Tooltip({ children, content, ...rest }) {
  const classes = useStyles();
  return (
    <MUITooltip
      className={classes.tooltip}
      arrow
      title={content}
      classes={{ popper: classes.poper }}
      // Without this, MUI closes the tooltip the instant the pointer
      // leaves the anchor — including when moving onto the tooltip's own
      // body to scroll it. Content taller than the max-height/overflow:
      // auto cap (see ./styles) was technically scrollable but
      // unreachable in practice: any attempt to mouse toward it closed
      // the tooltip first. `interactive` (a real MUI v4 prop — confirmed
      // in the installed Tooltip source) keeps it open while the pointer
      // is over the popper too, so the rest of the content is actually
      // reachable, not just present in the DOM.
      interactive
      {...rest}
    >
      {children || ""}
    </MUITooltip>
  );
}
